<template>
<div class="chapter">
<div class="inner_page">
      ﻿
<title>THE STORY DEVOTIONAL</title><link href="css/default.css" rel="stylesheet" type="text/css"/>
<p class="ctp" id="p0020-01-0"><a id="page14"></a><a href="#/contents#fn_13" id="sn_13">DAY 13</a></p>
<p class="ct"><a href="#/contents#fn_13">“BECAUSE YOU HAVE DONE THIS”</a></p>
<p class="ext"><span><i>To the woman [the L<span class="small">ORD</span> God] said,</i> </span></p>
<p class="ext" id="p0020-P-1"><span><i>“I will make your pains in childbearing very severe.”</i> </span></p>
<p class="ext" id="p0020-P-2"><span><i>To Adam he said,</i> </span></p>
<p class="ext" id="p0020-P-3"><span><i>“By the sweat of your brow</i> </span></p>
<p class="ext" id="p0020-P-4"><span><i>you will eat your food</i> </span></p>
<p class="ext" id="p0020-P-5"><span><i>until you return to the ground.”</i></span></p>
<p class="txr"><span><span class="small">GENESIS </span>3:16–17, 19</span></p>
<p class="tx1" id="p0020-04-4"><span class="dcap">T</span>hey had boldly disobeyed, but afterward neither was willing to take responsibility, to ask forgiveness, to repent. So the Holy God responded with a curse, but within God’s curses are reasons for hope.</p>
<p class="tx">The serpent was cursed, the woman would experience pain in childbirth, and the man would have to work hard to wrest food from the ground. Yet hear the promises and the hope. God made work harder for man, yet he limited the days of that hard work. Also, God’s holy wrath did not mean the end of the human race: the woman will know the joy of being a mother—and the woman’s offspring will one day crush the serpent’s.</p>
<p class="tx">Consequences and promises are intertwined in a pronouncement of judgment and mercy. God’s justice and his love for humanity intersect here in Eden.</p>
<p class="tx2">DON’T DOUBT GOD’S LOVE WHEN YOU ARE EXPERIENCING THE CONSEQUENCES OF YOUR ACTIONS.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter16.vue?2c072cf4